// One call per clock tick per league: everything time moves on its own.
// The web app's provider and the tests call this; the Durable Objects will
// do the equivalent on alarms (REALTIME.md).

import { advanceChat } from './chat';
import { advanceDraft } from './draft';
import type { SimState } from './league';
import { matchupSummary } from './views';
import { advanceWaivers } from './waivers';
import { advanceTrades } from './trades';
import { advanceAwards } from './awards';

/** Returns true when anything changed, so memoized views recompute. */
export function advanceLeague(state: SimState, now: number): boolean {
  const drafted = advanceDraft(state, now);
  const waived = advanceWaivers(state, now);
  const traded = advanceTrades(state, now);
  const chatted = advanceChat(state, now, (matchupId, at) => matchupSummary(state, matchupId, at));
  const awarded = advanceAwards(state, now);
  return drafted || waived || traded || chatted || awarded;
}
